import { gql } from "apollo-boost";

/* 구독박스 시작 */
export const ADMIN_DELIVERY_BOX_LIST_QUERY = gql`
  query AdminDeliveryBoxList(
    $skip: Int!
    $take: Int
    $keyword: String
    $type: String
    $deliveryStore_id: String
    $deliveryPlace_id: String
    $startDate: String
    $endDate: String
  ) {
    AdminDeliveryBoxList(
      skip: $skip
      take: $take
      keyword: $keyword
      type: $type
      deliveryStore_id: $deliveryStore_id
      deliveryPlace_id: $deliveryPlace_id
      startDate: $startDate
      endDate: $endDate
    ) {
      deliveryBoxes {
        id
        createdAt
        updatedAt

        state
        type
        deliveryPlace {
          id
          createdAt
          updatedAt

          commonStatus
          name
          managerName
          managerPhone
          zipcode
          jibunAddress
          roadAddress
          addressDetail
          longitude
          latitude
          dayOfWeek

          deliveryStore {
            id
            createdAt
            updatedAt

            store {
              id
              createdAt
              updatedAt

              name
            }
            user {
              id
              createdAt
              updatedAt

              name
            }
          }
        }
        deliveryAddress {
          id
          createdAt
          updatedAt

          commonStatus
          name
          zipcode
          jibunAddress
          roadAddress
          addressDetail
          dayOfWeek
          sido
          sigungu
          upmyundong
          li

          deliveryStore {
            id
            createdAt
            updatedAt

            store {
              id
              createdAt
              updatedAt

              name
            }
            user {
              id
              createdAt
              updatedAt

              name
            }
          }
        }
        user {
          id
          createdAt
          updatedAt

          commonStatus
          role
          useStoreApp
          confirmed
          blocked
          avatar
          userId
          email
          phone
          name
          sex
          birthDate
          zipcode
          roadAddress
          jibunAddress
          addressDetail

          isCms
          cmsValue
          cmsDay

          trustlines {
            id
            commonStatus
            currency
            amount
            createdAt
            updatedAt
          }
        }

        condition
        totalPrice
        deliveryDate
      }
      count
    }
  }
`;
export const ADMIN_DELIVERY_BOX_DETAIL_QUERY = gql`
  query AdminDeliveryBoxDetail($id: String!) {
    AdminDeliveryBoxDetail(id: $id) {
      id
      createdAt
      updatedAt

      state
      type
      deliveryPlace {
        id
        createdAt
        updatedAt

        commonStatus
        name
        managerName
        managerPhone
        zipcode
        jibunAddress
        roadAddress
        addressDetail
        longitude
        latitude
        dayOfWeek

        deliveryStore {
          id
          createdAt
          updatedAt

          store {
            id
            createdAt
            updatedAt

            name
          }
          user {
            id
            createdAt
            updatedAt

            name
          }
        }
      }
      deliveryAddress {
        id
        createdAt
        updatedAt

        commonStatus
        name
        zipcode
        jibunAddress
        roadAddress
        addressDetail
        dayOfWeek
        sido
        sigungu
        upmyundong
        li

        deliveryStore {
          id
          createdAt
          updatedAt

          store {
            id
            createdAt
            updatedAt

            name
          }
          user {
            id
            createdAt
            updatedAt

            name
          }
        }
      }
      deliveryBoxProducts {
        id
        createdAt
        updatedAt

        state
        price
        count
        totalPrice

        deliveryProduct {
          id
          createdAt
          updatedAt

          commonStatus
          timestamp
          coverImage
          price
          name
          description
        }
        deliveryProductOptionDetail1 {
          id
          createdAt
          updatedAt

          commonStatus
          price
          name
        }
        deliveryProductOptionDetail2 {
          id
          createdAt
          updatedAt

          commonStatus
          price
          name
        }
        deliveryProductOptionDetail3 {
          id
          createdAt
          updatedAt

          commonStatus
          price
          name
        }
      }
      user {
        id
        createdAt
        updatedAt

        commonStatus
        role
        useStoreApp
        confirmed
        blocked
        avatar
        userId
        email
        phone
        name
        sex
        birthDate
        zipcode
        roadAddress
        jibunAddress
        addressDetail

        isCms
        cmsValue
        cmsDay

        trustlines {
          id
          commonStatus
          currency
          amount
          createdAt
          updatedAt
        }
      }

      condition
      totalPrice
      deliveryDate
    }
  }
`;
export const ADMIN_DELIVERY_BOX_ORDER_MUTATION = gql`
  mutation AdminDeliveryBoxOrder($id: String!) {
    AdminDeliveryBoxOrder(id: $id)
  }
`;
/* 구독박스 끝 */

/* 구독박스 주소 시작 */
export const ADMIN_DELIVERY_ADDRESS_LIST_QUERY = gql`
  query AdminDeliveryAddressList(
    $deliveryBox_id: String!
    $skip: Int!
    $take: Int
  ) {
    AdminDeliveryAddressList(
      deliveryBox_id: $deliveryBox_id
      skip: $skip
      take: $take
    ) {
      deliveryAddresses {
        id
        createdAt
        updatedAt
        commonStatus
        name
        zipcode
        jibunAddress
        roadAddress
        addressDetail
        longitude
        latitude
        dayOfWeek
        sido
        sigungu
        upmyundong
        li

        deliveryStore {
          id
          createdAt
          updatedAt

          store {
            id
            createdAt
            updatedAt

            name
          }
          user {
            id
            createdAt
            updatedAt

            name
          }
        }
        user {
          id
          createdAt
          updatedAt

          commonStatus
          role
          useStoreApp
          confirmed
          blocked
          avatar
          userId
          email
          phone
          name
          sex
          birthDate
          zipcode
          roadAddress
          jibunAddress
          addressDetail

          isCms
          cmsValue
          cmsDay

          trustlines {
            id
            commonStatus
            currency
            amount
            createdAt
            updatedAt
          }
        }
      }
      count
    }
  }
`;
export const ADMIN_DELIVERY_ADDRESS_WRITE_MUTATION = gql`
  mutation AdminDeliveryAddressWrite(
    $name: String!
    $zipcode: String!
    $jibunAddress: String!
    $roadAddress: String!
    $addressDetail: String!
    $longitude: String
    $latitude: String
    $dayOfWeek: String!
    $sido: String!
    $sigungu: String!
    $upmyundong: String!
    $li: String
    $deliveryBox_id: String!
  ) {
    AdminDeliveryAddressWrite(
      name: $name
      zipcode: $zipcode
      jibunAddress: $jibunAddress
      roadAddress: $roadAddress
      addressDetail: $addressDetail
      longitude: $longitude
      latitude: $latitude
      dayOfWeek: $dayOfWeek
      sido: $sido
      sigungu: $sigungu
      upmyundong: $upmyundong
      li: $li
      deliveryBox_id: $deliveryBox_id
    )
  }
`;
export const ADMIN_DELIVERY_ADDRESS_DETAIL_QUERY = gql`
  query AdminDeliveryAddressDetail($id: String!) {
    AdminDeliveryAddressDetail(id: $id) {
      id
      createdAt
      updatedAt
      commonStatus
      name
      zipcode
      jibunAddress
      roadAddress
      addressDetail
      longitude
      latitude
      dayOfWeek
      sido
      sigungu
      upmyundong
      li

      deliveryStore {
        id
        createdAt
        updatedAt

        store {
          id
          createdAt
          updatedAt

          name
        }
        user {
          id
          createdAt
          updatedAt

          name
        }
      }
      user {
        id
        createdAt
        updatedAt

        commonStatus
        role
        useStoreApp
        confirmed
        blocked
        avatar
        userId
        email
        phone
        name
        sex
        birthDate
        zipcode
        roadAddress
        jibunAddress
        addressDetail

        isCms
        cmsValue
        cmsDay

        trustlines {
          id
          commonStatus
          currency
          amount
          createdAt
          updatedAt
        }
      }
    }
  }
`;
export const ADMIN_DELIVERY_ADDRESS_EDIT_MUTATION = gql`
  mutation AdminDeliveryAddressEdit(
    $id: String!
    $name: String!
    $zipcode: String!
    $jibunAddress: String!
    $roadAddress: String!
    $addressDetail: String!
    $longitude: String
    $latitude: String
    $dayOfWeek: String!
    $sido: String!
    $sigungu: String!
    $upmyundong: String!
    $li: String
  ) {
    AdminDeliveryAddressEdit(
      id: $id
      name: $name
      zipcode: $zipcode
      jibunAddress: $jibunAddress
      roadAddress: $roadAddress
      addressDetail: $addressDetail
      longitude: $longitude
      latitude: $latitude
      dayOfWeek: $dayOfWeek
      sido: $sido
      sigungu: $sigungu
      upmyundong: $upmyundong
      li: $li
    )
  }
`;
export const ADMIN_DELIVERY_ADDRESS_DELETE_MUTATION = gql`
  mutation AdminDeliveryAddressDelete($id: String!) {
    AdminDeliveryAddressDelete(id: $id)
  }
`;

/* 구독박스 주소 끝 */

/* 요일별 주문현황 시작 */
export const ADMIN_DELIVERY_BOX_DAYOFWEEK_QUERY = gql`
  query AdminDeliveryBoxDayOfWeek($deliveryStore_id: String) {
    AdminDeliveryBoxDayOfWeek(deliveryStore_id: $deliveryStore_id) {
      dayOfWeek
      deliveryBoxDayOfWeek {
        dayOfWeek
        deliveryProduct_id
        deliveryProduct_name
        deliveryProductOptionDetail1_name
        deliveryProductOptionDetail2_name
        deliveryProductOptionDetail3_name
        sum
        count
      }
    }
  }
`;
/* 요일별 주문현황 */
